import {
  PageBlueprint,
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import {
  compatWrapper,
  convertLegacyRouteRef,
  convertLegacyRouteRefs,
} from '@backstage/core-compat-api';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';

import { rootRouteRef } from './routes';

// A top-level page rather than an entity tab, deliberately.
//
// A Datadog secure embed is scoped to a dashboard, and carries no viewer
// identity - so there is nothing to key off an entity and no way to make the
// same embed show service-specific data. Hanging it off one arbitrary component
// would just hide a platform-wide view somewhere unfindable. If a genuinely
// per-service dashboard turns up later, an EntityContentBlueprint resolving an
// annotation to one of these configured ids is the shape to add.
//
// `title` and `icon` are what put this in the sidebar: PageBlueprint emits
// core.title/core.icon only when they are supplied, and the app's Sidebar renders
// nav.rest() over the nav items that exist rather than synthesising one from a
// registered route. Without them the page is reachable at its path and invisible
// everywhere else.
const datadogPage = PageBlueprint.make({
  params: {
    path: '/datadog',
    title: 'Datadog',
    icon: <MonitorHeartIcon />,
    routeRef: convertLegacyRouteRef(rootRouteRef),
    async loader() {
      const { DatadogDashboardPage } = await import('./components');
      return compatWrapper(<DatadogDashboardPage />);
    },
  },
});

export const datadogDashboardPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'datadog-dashboard',
  extensions: [datadogPage],
  routes: convertLegacyRouteRefs({
    root: rootRouteRef,
  }),
});
